<script lang="ts">
	export let data;
</script>

<div class="flex">
	{#if data}
		<div class="text-ellipsis overflow-hidden whitespace-nowrap">
			{data}
		</div>
	{/if}
</div>
